<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<div fxLayout="column">
  <!-- <-- <div class="w-100 mb-1 example-container" [formGroup]="logsForm" fxLayout="row" fxLayoutAlign="center center">
    <mat-form-field class="mb-0" appearance="fill">
      <mat-label>Choose a date</mat-label>
      <input matInput formControlName="date" name="date" [matDatepicker]="picker">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="mb-0" appearance="fill">
      <mat-label>Id Contratto</mat-label>
      <mat-select formControlName="idContratto" name="idContratto">
        <mat-option value="" aria-selected="true"></mat-option>
        <mat-option value="[info]">Info</mat-option>
        <mat-option value="[error]">Error</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="mb-0" appearance="fill">
      <mat-label>Id Box</mat-label>
      <mat-select formControlName="idBox" name="idBox">
        <mat-option value="" aria-selected="true"></mat-option>
        <mat-option value="[info]">Info</mat-option>
        <mat-option value="[error]">Error</mat-option>
      </mat-select>
    </mat-form-field> -->
  <!-- <button mat-icon-button type="submit" color="primary" aria-label="Example icon button with a home icon"
      (click)="fetchStreamLogs()">
      <mat-icon style="font-size: 70px; line-height: 5px;">pageview</mat-icon>
    </button> -->
  <!-- </div> -->

  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
    </div>

    <table (matSortChange)="doSortItems($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>


      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> Num. </th>
        <td mat-cell *matCellDef="let i = dataIndex">{{paginatorUsers.pageIndex * paginatorUsers.pageSize + i + 1}}</td>
      </ng-container>

      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by date">
          Timestamp (UTC)
        </th>
        <td mat-cell *matCellDef="let element"> {{element.timestamp | date:'dd/MM/yyyy HH:mm:ss': 'UTC'}} </td>
      </ng-container>
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
          Source </th>
        <td mat-cell *matCellDef="let element"> {{element.source}} </td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
          Duration (seconds)</th>
        <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
          Type </th>
        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
      </ng-container>


      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
          Message </th>
        <td mat-cell *matCellDef="let element"> {{element.message | boxLogs }} </td>
      </ng-container>


      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td mat-cell *matCellDef="let element" class="text-right">
          <button mat-icon-button (click)="detectURLs(element.id)" matTooltip="Download file">
            <mat-icon>download</mat-icon>
            <!-- <label>{{element.message}}</label> -->
          </button>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="headers"></tr>
      <tr mat-row *matRowDef="let row; columns: headers;"></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="headers.length" class="mat-cell text-center">
          No boxes found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorTamperingAttemptLogs [fxShow]="dataSource && dataSource.data.length > 10"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>